// eslint-disable-next-line import/named
import { captureException } from '@sentry/react';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { ViteEnv } from '@/env';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export const sendErrorToSentry = (error: Error): void => {
  captureException(error);
};

export const removeEmptyStrings = <T extends Record<string, unknown>>(
  obj: T,
): T => {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== ''),
  ) as T;
};

export const getSlackRedirectUrl = (accessToken: string): string => {
  const encodedToken = btoa(accessToken);

  return `${ViteEnv.VITE_SLACKBOT_URL}/slack/oauth/install?r=${encodedToken}`;
};
